
import { InteractivePointInfo } from "./InteractivePointInfo";
import { InteractivePointSelection } from "./InteractivePointSelection";
import { InteractivePointText } from "./InteractivePointText";
import { TYPE_POINTS } from "../../utils/constants";
import { useSelector } from "react-redux";

const POINTS = {
    [TYPE_POINTS.INFO]: InteractivePointInfo,
    [TYPE_POINTS.SELECTION]: InteractivePointSelection,
    [TYPE_POINTS.TEXT]: InteractivePointText,
}



export default function InteractivePoint(props) {

    const { id, type, onAnswer, isCurrentQuestion, onClick, setShowMessage, passScreenHandler, setIsInfoScreenActive, isInfoScreenActive, setIsInputOpen } = props;

    const Component = POINTS[type];
    const disabled = useSelector(state => state.game.isAnimating || !state.game.isCompleteEntryAnimation);
    return (
        <Component
            id={id}
            onAnswer={onAnswer}
            disabled={disabled}
            isCurrentQuestion={isCurrentQuestion}
            onClick={onClick}
            passScreenHandler={passScreenHandler}
            setShowMessage={setShowMessage}
            setIsInfoScreenActive={setIsInfoScreenActive}
            isInfoScreenActive={isInfoScreenActive}
            setIsInputOpen={setIsInputOpen} 
        />
    )

}